import Employee from "./Employee/Employee";
import Notification from "./Notification";
import UserRoles from "./UserManagement/Roles/UserRoles";
import UserManagement from "./UserManagement/UserManagement";

export default { Employee, UserManagement, Notification, UserRoles };
